import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import CtitemDashboard from '../CtitemDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function CtitemPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < CtitemDashboard />
    )

}